import getEventDurationDisplayString from 'mini-common-utils/lib/utils/getEventDurationDisplayString';
import { CalendarEvent } from 'mini-calendar-event-types';
import { format } from 'owa-strings';
import { formatDateMonthShort } from 'mini-common-utils/lib/utils/calendarDateFormatUtils';
import { formatShortHourOrTime } from 'owa-datetime';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { getRelativeDayString } from 'mini-common-utils/lib/utils/getRelativeDayString';

/**
 * Given an item, this returns the title for the item to be shown in the rsvp infobar or the rsvp action bar
 * @param item
 */
export const getRsvpUnitTitle = (item: CalendarEvent): string => {
    const strings = getOwaMiniCommonStrings();
    const { Start, End } = item;

    // get the title
    const title: string = format(
        strings.eventTimeDurationTitle,
        getRelativeDayString(Start) || formatDateMonthShort(Start), // Date
        formatShortHourOrTime(Start), // Time
        getEventDurationDisplayString(Start, End, true /**useSHortFormatOnly */) // duration
    );

    return title;
};
